const state = {
  countries: [],
  idProofs : [],
  tourTypes: [],
  genders: [],
  pendingVisitors: []
}

const getters = {}

const actions = {
  getCountries ({ commit }) {
    axios
      .get("/samadh/countries")
      .then(response => (commit('setCountries', response.data)));
  },
  getIdProofs ({ commit }) {
    axios
      .get("/samadh/idproofs")
      .then(response => (commit('setIdProofs', response.data)));
  },
  getTourTypes ({ commit }) {
    axios
      .get("/samadh/tourtypes")
      .then(response => (commit('setTourTypes', response.data)));
  },
  getGenders ({ commit }) {
    axios
      .get("/samadh/genders")
      .then(response => (commit('setGenders', response.data)));
  },
  getVisitorsByMobile ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/samadh/visitor-mobile-search", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })

  },
  updateVisitStatus ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/samadh/visit-status", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  updateVisitHours ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/samadh/update-visit-hours", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },

  getEntryVisitors ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/samadh/visitors-entry-report", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  printReceipt ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("http://localhost:8000/print/", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getPendingVisitors ({ commit }) {
    axios
      .get("/samadh/pending-visitors")
      .then(response => (commit('setPendingVisitors', response.data)));
  },
  createVisit ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/samadh/visit", params, {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
}

const mutations = {
  setCountries (state, data) {
    state.countries = data.data;
  },
  setIdProofs(state, data){
    state.idProofs = data.data;
  },
  setTourTypes(state, data){
    state.tourTypes = data.data;
  },
  setGenders(state, data){
    state.genders = data.data;
  },
  setPendingVisitors(state, data){
    state.pendingVisitors = data.data;
  }



}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
